import Status from "components/General/Status";
import { toCamelCase } from "helpers/Audit/AuditHelpers";
import { IAccount } from "interfaces/Account/IAccount";
import { useEffect, useState } from "react";
import Moment from "react-moment";

const AccountStatusAuditEntry = ({ responseBody, requestor, timestamp }) => {
  const [account, setAccount] = useState<IAccount>();

  useEffect(() => {
    try {
      const account = JSON.parse(responseBody, toCamelCase);
      if (account) {
        setAccount(account);
      }
    } catch (e) {
      console.log("Invalid json in audit response body");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {account && (
        <tr>
          <td>
            <Status
              archived={account?.archived}
              suspended={account?.suspended}
            />
          </td>
          <td>{requestor}</td>
          <td>
            <Moment format="DD/MM/YYYY">{timestamp}</Moment>
          </td>
          <td>
            <Moment format="HH:mm:ss">{timestamp}</Moment>
          </td>
        </tr>
      )}
    </>
  );
};

export default AccountStatusAuditEntry;
